<template>
  <div>
    <v-expansion-panels elevation="0">
      <v-expansion-panel elevation="0">
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Fecha a renovar"
                  v-model="form.fecha"
                  type="date"
                  :rules="rulesFor('fecha')"
                  required
                  outlined
                  color="#b11f1f"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="pt-5">
      <v-row dense justify="end">
        <v-col cols="auto">
          <v-btn class="common-botton" dark min-width="120" @click="filtrar" :disabled="!form.fecha || loading" :loading="loading">
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        fecha: null,
      },
    };
  },
  methods: {
    rulesFor(field) {
      const required = [(v) => !!v || "El campo es requerido"];

      if (field === "fecha") {
        return [
          ...required,
          (v) =>
            moment(v).isSameOrBefore(moment(), "day") ||
            "La fecha no puede ser futura",
        ];
      }

      return required;
    },
    filtrar() {
      if (this.$refs.form.validate()) {
        this.$emit("searchUpdated", this.form);
      }
    },
  },

  mounted() {},
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(
    .v-expansion-panels--tile
  )
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #fcf2f2;
}
.v-expansion-panel-header {
  background-color: #fcf2f2;
  border-radius: 20px !important;
}
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  width: 300px;
  height: 40px !important;
  font-size: small;
  font-weight: bold;
  margin-top: 10px;
}
</style>
